import { RoiService } from './roi.service';
import { Company, ApiWebHook } from './../model/settings.model';
import { Tchekb } from './../model/tchekb.model';
import { ParametersService } from './parameters.service';
 import { Injectable } from '@angular/core';
import { Report, ReportChecklist } from '../model/report.model';
import { ParseAPIService, DbObjectsStore } from '../abstract/ParseAPIService';
import { Base64 } from 'aws-sdk/clients/ecr';
import 'parse';
import { DefinitionChecklist } from '../model/definition-checklist.model';
import { error } from 'protractor';
import { Subject } from 'rxjs';
import { VehiculeChecklist } from '../model/reportChecklist';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const parse: typeof Parse = require('parse');


@Injectable()
export class ReportService implements ParseAPIService<Report> {
  store: DbObjectsStore<Report>;
  checklistDefinitions: Promise<DefinitionChecklist[]>;
  settings : any;

  constructor(private readonly _parametersService: ParametersService, private http: HttpClient,
	private readonly _roiService : RoiService) {
    this.store = {};
    if(parse.User.current().get('companyPtr').get('settingsPtr')){
      this.settings = parse.User.current().get('companyPtr').get('settingsPtr').get('report')?parse.User.current().get('companyPtr').get('settingsPtr').get('report').selectorReport:"";
    }else{
      this.settings="simple"
    }
    this.checklistDefinitions = this.initializeDefinitions();
  }

  public async getAll(limit?: number): Promise<Report[]> {
    const query = this.baseQuery();
    if (typeof limit === 'number')
      query.limit(limit);
    try {
      const foundObjects = await query.find();
      foundObjects.forEach(o => this.store[o.id] = new Report(o));
      return Object.values(this.store);
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  public async get(id: string): Promise<Report> {
    const query = this.baseQuery();
    try {
      this.store[id] = new Report(await query.get(id));
      if(this.store[id].typeReport===undefined)this.store[id].typeReport='simple'
      if (this.store[id].typeReport !== 'state' && this.store[id].typeReport !== 'simple')
      {
        this.store[id].typeReport = this.settings;
      }
      
      return this.store[id];
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }



  public async getOutReport(report : Report): Promise<any> {
    if (report.outReportId)
      return this.get(report.outReportId)
    else{
    const query = this.baseQuery();
    try {
      let v = {
        __type: "Pointer",
        className: "Vehicle",
        objectId: report.tchekPtr.vehiclePtr.id
      };
      let t = {
        __type: "Pointer",
        className: "Tchek",
        objectId: report.tchekPtr.id
      };
      let dataS;
      let dataR = await query.notEqualTo('tchekPtr', t)
      .equalTo('vehiclePtr', v)
      .lessThanOrEqualTo("createdAt", report.createdAt)
      .descending("createdAt")
      .first()
      .then((data) => {
        if (data)
        {
          dataS = data
          let result = new Report(data)
          if (result.typeReport !== "state"
            || result.contractWay !== "out")
            return "error"
          else {
              return result
          }
        } else
        return "error"
      })
      if (dataR !== 'error'){
      report.outReportId = dataS.id;
      return this.save(report).then((saved: any) => {
        return dataR
      });}
      else {
        return dataR
      }
    } catch (e) {
      console.error(e);
      return "error";
    }
  }
  }

  public async notifySI(tchekId: string) {
     parse.Cloud.run('notifySI', { tchekId });
  }

  public async create(tchekId: string): Promise<Report> {
    const reportId = await parse.Cloud
      .run('createReport', { tchekId });
    return await this.get(reportId);
  }

  public async getByTchek(id: string): Promise<Report[]> {
    const query = this.baseQuery().descending('createdAt');
    const tchek = new parse.Object('Tchek');
    tchek.id = id;
    let tchekPtr = {
      __type: "Pointer",
      className: "Tchek",
      objectId: id
    };
    try {
      //await tchek.fetch();
      const reportsFound = [];
      (await query.equalTo('tchekPtr', tchekPtr).find())
        .forEach(r => {
          this.store[r.id] = new Report(r);
          reportsFound.push(this.store[r.id]);
        });
      return reportsFound;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveChecklist(report: Report, checklist: VehiculeChecklist[]): Promise<any> {
      try {
        report.vehicleChecklist = checklist
        //console.log("checklist to save #########", report.vehicleChecklist);
        const savedObjects = await report.getParseInstance().save();
        //console.log("Checklist report ########### saved", savedObjects);
        return savedObjects;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    
  }

  public async save(report: Report | Report[]): Promise<Report | Report[]> {
    if (Array.isArray(report)) {
      const array = report.map<Parse.Object>(r => r.getParseInstance());
      try {
        const savedObjects = await parse.Object.saveAll(array);
        return savedObjects.map<Report>(o => new Report(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const savedObject = await report.getParseInstance().save();
        return new Report(savedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async saveSignature(report: Report, base64 : Base64, unset? : boolean): Promise<any> {
    if (unset){
      try {
        report.getParseInstance().unset("signatorySignature")
        report.signatorySignature = null;
        const savedObjects = await report.getParseInstance().save();
        return savedObjects;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
    else{
      try {
        let parseFile = new parse.File("signature.png", {'base64' : base64});
        report.getParseInstance().set("signatorySignature", parseFile)
        report.signatorySignature = parseFile;
        const savedObjects = await report.getParseInstance().save();
        return savedObjects;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  // TODO: implement logic deletion
  public async delete(report: Report | Report[]): Promise<Report | Report[]> {
    throw new Error('Not implemented');
  }

  public async destroy(report: Report | Report[]): Promise<Report | Report[]> {
    if (Array.isArray(report)) {
      const array = report.map<Parse.Object>(r => r.getParseInstance());
      try {
        const destroyedObjects = await parse.Object.destroyAll(array);
        return destroyedObjects.map<Report>(o => new Report(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const destroyedObject = await report.getParseInstance().destroy();
        return new Report(destroyedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  private async initializeDefinitions(): Promise<DefinitionChecklist[]> {
    try {
      const query = new parse.Query('DefinitionChecklist');
      const defs = await query.find();
      return defs.map<DefinitionChecklist>(d => new DefinitionChecklist(d));
    } catch (e) {
      console.error('Could not retrieve checklist defs', e);
      return [];
    }
  }

  public async checklistKeyToLabel(key: string): Promise<string> {
    const def = (await this.checklistDefinitions).find(d => d.key === key);
    return def.labelFr;
  }

  private baseQuery(): Parse.Query {
    return new parse.Query('Report').include([, 'tchekPtr', 'tchekPtr.vehiclePtr', 'tchekPtr.devicePtr']);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/report.service.ts